module.exports = __webpack_public_path__ + "static/media/comma2.3bda9188.png";